import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";
export function Progress(t0) {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      value: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const value = t1 === undefined ? 0 : t1;
  const clamped = Math.max(0, Math.min(100, value));
  let t2;
  if ($[4] !== className) {
    t2 = cn("relative h-2 w-full overflow-hidden rounded-full bg-secondary", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `${clamped}%`;
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="h-full bg-primary transition-[width] duration-500" style={{
      width: t3
    }} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== t2 || $[10] !== t4) {
    t5 = <div className={t2} {...props}>{t4}</div>;
    $[8] = props;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}